import React from 'react';

export default function Logo(): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 184 60" height="62">
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="21.38"
          y1="26"
          x2="53.38"
          y2="26"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#d7e6ff" />
          <stop offset="1" stopColor="#76abff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="5.38"
          y1="34"
          x2="37.38"
          y2="34"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7878ff" />
          <stop offset="1" stopColor="#130ed8" />
        </linearGradient>
      </defs>
      <path
        fill="url(#linear-gradient)"
        d="M38.38,8h-2c-10.81,0-15,2.27-15,17.75v.5c0,15.48,4.19,17.75,15,17.75h2c10.81,0,15-2.27,15-17.75v-.5c0-15.48-4.19-17.75-15-17.75Z"
      />
      <path
        fill="url(#linear-gradient-2)"
        d="M22.38,16h-2c-10.81,0-15,2.27-15,17.75v.5c0,15.48,4.19,17.75,15,17.75h2c10.81,0,15-2.27,15-17.75v-.5c0-15.48-4.19-17.75-15-17.75Z"
      />
      <path
        fill="#0047de"
        d="M37.38,34v-.25c0-15.48-4.19-17.75-15-17.75h-.06c-.64,2.45-.94,5.63-.94,9.75v.5c0,15.48,4.19,17.75,15,17.75h.06c.64-2.45.94-5.63.94-9.75v-.25Z"
      />
      <path
        fill="#222"
        d="M82.7,22.82c-1.22-2.12-2.9-3.77-5.03-4.97-2.13-1.2-4.5-1.8-7.11-1.8h-9.18v27.94h9.18c2.61,0,4.98-.61,7.11-1.84,2.13-1.22,3.8-2.91,5.03-5.07,1.22-2.16,1.84-4.55,1.84-7.19s-.61-4.97-1.84-7.08ZM78.59,34.81c-.77,1.46-1.83,2.61-3.17,3.45-1.34.84-2.85,1.26-4.53,1.26h-4.83v-19h4.83c1.68,0,3.19.4,4.55,1.2,1.36.8,2.42,1.91,3.17,3.33.76,1.42,1.14,3.04,1.14,4.85s-.39,3.45-1.16,4.91Z"
      />
      <path
        fill="#222"
        d="M88.73,20.92c-.56-.56-.84-1.22-.84-2s.28-1.44.84-2.02c.61-.63,1.36-.91,2.23-.85.69.05,1.32.35,1.8.85.56.57.84,1.24.84,2.02s-.28,1.44-.84,2c-.49.49-1.12.78-1.81.83-.87.06-1.61-.22-2.22-.83ZM92.92,24.48v19.52h-4.43v-17.02c0-1.38,1.12-2.5,2.5-2.5h1.93Z"
      />
      <path
        fill="#222"
        d="M173.75,20.92c-.56-.56-.84-1.22-.84-2s.28-1.44.84-2.02c.61-.63,1.36-.91,2.23-.85.69.05,1.32.35,1.8.85.56.57.84,1.24.84,2.02s-.28,1.44-.84,2c-.49.49-1.12.78-1.81.83-.87.06-1.61-.22-2.22-.83ZM177.94,24.48v19.52h-4.43v-17.02c0-1.38,1.12-2.5,2.5-2.5h1.93Z"
      />
      <path
        fill="#222"
        d="M98.94,42.61c-1.54-1.18-2.41-2.81-2.59-4.89h4.27c.08.85.49,1.54,1.24,2.06.74.52,1.68.78,2.79.78s1.9-.21,2.51-.62c.61-.41.92-.96.92-1.66,0-.8-.36-1.36-1.08-1.7s-1.85-.66-3.39-.98c-1.44-.27-2.61-.56-3.51-.88-.91-.32-1.68-.85-2.34-1.6s-.98-1.77-.98-3.07c0-1.14.3-2.17.9-3.07.6-.9,1.46-1.62,2.57-2.14,1.12-.52,2.42-.78,3.91-.78,2.1,0,3.9.54,5.41,1.62,1.5,1.08,2.36,2.57,2.57,4.49h-4.47c-.11-.69-.49-1.26-1.14-1.72s-1.47-.68-2.45-.68c-.88,0-1.6.18-2.16.54s-.84.84-.84,1.46c0,.72.33,1.22.98,1.52.65.29,1.71.57,3.17.84,1.49.27,2.71.57,3.67.92.96.35,1.78.92,2.48,1.74s1.04,1.96,1.04,3.45c0,1.14-.33,2.19-.98,3.13-.65.95-1.56,1.68-2.71,2.22-1.16.53-2.44.8-3.85.8-2.42,0-4.4-.59-5.95-1.78Z"
      />
      <path
        fill="#222"
        d="M135.59,29.12c-.84-1.58-2-2.83-3.47-3.74-1.5-.92-3.27-1.37-5.03-1.3-1.4.05-2.64.39-3.71,1.01-1.17.68-2.12,1.64-2.83,2.89v-3.51h-1.93c-1.38,0-2.5,1.12-2.5,2.5v23.84h4.43v-10.34c.72,1.25,1.66,2.22,2.83,2.89,1.06.62,2.29.95,3.69,1.01,1.76.07,3.54-.37,5.04-1.29,1.48-.91,2.64-2.16,3.49-3.75.82-1.56,1.24-3.25,1.24-5.09s-.41-3.57-1.24-5.13ZM131.66,37.2c-.52.91-1.23,1.62-2.14,2.16-.9.53-1.9.8-2.99.8s-2.13-.26-3.03-.78c-.91-.52-1.62-1.23-2.14-2.14-.52-.9-.78-1.9-.78-2.99s.26-2.13.78-3.03c.52-.91,1.23-1.62,2.14-2.14.9-.52,1.92-.78,3.03-.78s2.09.27,2.99.8c.9.53,1.62,1.25,2.14,2.15.52.91.78,1.9.78,2.99s-.26,2.05-.78,2.95Z"
      />
      <path
        fill="#222"
        d="M144.73,43.99h-4.43v-25.44c0-1.38,1.12-2.5,2.5-2.5h1.93v27.94Z"
      />
      <path
        fill="#222"
        d="M166.87,24.47c-1.38,0-2.5,1.12-2.5,2.5v1.01c-.72-1.25-1.66-2.22-2.83-2.89-1.07-.62-2.31-.96-3.71-1.01-1.76-.07-3.54.38-5.04,1.3-1.48.91-2.63,2.16-3.47,3.74-.83,1.56-1.24,3.25-1.24,5.09s.41,3.57,1.24,5.13c.84,1.59,2,2.84,3.49,3.75,1.5.92,3.28,1.36,5.05,1.29,1.39-.06,2.62-.39,3.68-1.01,1.17-.68,2.11-1.64,2.83-2.89v3.51h4.47v-19.52h-1.97ZM163.55,37.24c-.52.91-1.23,1.62-2.14,2.14-.91.52-1.92.78-3.03.78s-2.09-.27-2.99-.8c-.9-.53-1.62-1.25-2.14-2.16-.52-.9-.78-1.9-.78-2.99s.26-2.05.78-2.95c.52-.9,1.23-1.62,2.14-2.15.91-.53,1.9-.8,2.99-.8s2.13.26,3.03.78c.9.52,1.62,1.23,2.14,2.14.52.9.78,1.9.78,2.99s-.26,2.13-.78,3.03Z"
      />
    </svg>
  );
}
